<template>
  <v-container class="Profil">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <v-toolbar v-if="item" class="my-md-auto " elevation="0" rounded="lg">
      <v-toolbar-title  class="hidden-md-and-down">
          <h2><v-icon large class="mr-2"  >mdi-account-group</v-icon>{{ item['name'] }}</h2>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          class="ml-2"
          :to="{ name: 'ProfilUserList' }"
        >
          {{ $t('global.back')}}
        </v-btn>
        <v-btn
          class="ml-2"
          v-if="userHasAccess('profil_edit')"
          color="primary"
          :to="{ name: 'ProfilUserUpdate' , params: { id: item['@id'] } }"
        >
          {{ $t('global.update')}}
        </v-btn>
      </div>
    </v-toolbar>

    <div  v-if="item">
      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="6" >
              <strong class="ml-4">{{ $t('global.name') }}:</strong>
            </v-col>
            <v-col md="6">
              <span class="mr-2">{{ item['name'] }}</span>
            </v-col>
          </v-row>

        </v-col>


      </v-row>
      <v-row>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="6" >
              <strong class="ml-4">{{ $t('global.dateCreation') }}:</strong>
            </v-col>
            <v-col md="6">
              <span class="mr-2">{{ formatDateTime(item['dateCreation'], 'long') }}</span>
            </v-col>
          </v-row>

        </v-col>
        <v-col md="6">
          <v-divider></v-divider>
          <v-row>
            <v-col md="6" >
              <strong class="ml-4">{{ $t('global.dateUpdate') }}:</strong>
            </v-col>
            <v-col md="6">
              <span class="mr-2">{{ formatDateTime(item['dateUpdate'], 'long') }}</span>
            </v-col>
          </v-row>

        </v-col>

      </v-row>

      <v-divider  ></v-divider>
      <br>
      <div  class="ml-2">
        <h3 class="text-decoration-underline">{{ $t('global.access') }}</h3>
      </div>

      <v-row  >
        <v-col md="6" v-for="access in this.Accessitems" :key="access.id">

          <v-row align="center" class="pa-0 ml-0">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('administration.access.'+ access.name) }}:</strong>
            </v-col>
            <v-col md="4" class="pa-0 ml-0">
              <v-switch v-if="hasAccess(access)"
                color="primary"
                value
                class="pa-0 ml-0"
                dense
                input-value="true"
                disabled
              ></v-switch>
              <v-switch v-else
                disabled
                dense
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-divider  ></v-divider>
      <br>
      <div  class="ml-2">
        <h3 class="text-decoration-underline">{{ $t('administration.user.users') }}</h3>
      </div>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="useritems"
        :items-per-page.sync="options.itemsPerPage"
        :loading="isLoading"
        :loading-text="$t('global.loading')"
        :options.sync="options"
        :server-items-length="totalItems"
        class="elevation-1"
        item-key="@id"
        @update:options="onUpdateOptions"
@click:row="showHandlerSubEvent"
      >
            <template slot="item.enabled" slot-scope="{ item }">
              <strong v-if="item.enabled" >
                <v-icon color="green">mdi-check-circle</v-icon>
              </strong>
              <span v-else>
                <v-icon color="red">mdi-close-circle</v-icon>
              </span>
            </template>
        <ActionCell
          slot="item.action"
          slot-scope="props"
          :handle-show="() => showHandlerSub(item,'User',props.item)"
        ></ActionCell>
      </v-data-table>
    </div>
    </v-sheet>
      <Loading :visible="isLoading" />
  </v-container>

</template>


<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';

const servicePrefix = 'Profil';

export default {
  name: 'ProfilUserShow',
  servicePrefix,
  components: {
      Loading,
      ActionCell,
  },
  mixins: [ShowMixin,AccessMixin,ListMixin],
  data() {
    return {
      headers: [
        { text: this.$t('administration.user.login'), value: 'login' },
        { text: this.$t('administration.user.firstname'), value: 'firstname' },
        { text: this.$t('administration.user.lastname'), value: 'lastname' },
        { text: this.$t('administration.user.enabled'), value: 'enabled' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      filters: {
        'profil' : this.$route.params.id,
      },
      selected: []
    };
  },
  computed: {
    ...mapFields('profil', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('profil', ['find']),
    ...mapGetters('accesses', {
      Accessitems: 'list'
    }),
    ...mapGetters('user', {
      useritems: 'list'
    }),
    ...mapFields('user', {
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('profil', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),
    ...mapActions('accesses', {
      fetchAll: 'fetchAll',
    }),
    ...mapActions('user', {
      getPage: 'fetchAll',
    }),
    hasAccess (access) {
      if (access) {
        for (let x in this.item.access) {
          if(access['@id'] == this.item.access[x]['@id']){
            return true;
          }
        }
      }
      return false;
    },
    showHandlerSubEvent(value) {
      this.showHandlerSub(this.item,'User',value);
    }
  },
  mounted() {
    this.fetchAll({'pagination' : false});

 },

};
</script>
